import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Loader2 } from "lucide-react";
import { useApp } from "@/context/AppContext";

export default function Orders() {
  const { user, setAuthOpen } = useApp();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) { setAuthOpen(true); setLoading(false); return; }
    api.get("/orders").then(({ data }) => setOrders(data.orders)).finally(() => setLoading(false));
  }, [user, setAuthOpen]);

  if (!user) return (
    <div className="max-w-[900px] mx-auto px-6 py-24 text-center">
      <h1 className="font-display font-black text-4xl tracking-tighter">Sign in to view orders.</h1>
    </div>
  );

  return (
    <div className="max-w-[1200px] mx-auto px-6 md:px-10 py-12">
      <div className="font-mono-brand text-xs uppercase tracking-[0.3em] text-neutral-500">/ history</div>
      <h1 className="font-display font-black text-5xl md:text-6xl tracking-tighter mt-2">Orders.</h1>

      {loading ? (
        <div className="flex items-center gap-2 text-neutral-500 mt-10"><Loader2 className="w-4 h-4 animate-spin" /> Loading…</div>
      ) : orders.length === 0 ? (
        <div className="mt-12 text-neutral-500">
          No orders yet. <Link to="/shop/all" className="underline hover:text-[#FF3B30]">Start browsing →</Link>
        </div>
      ) : (
        <div className="mt-10 space-y-6">
          {orders.map((o) => (
            <div key={o.id} className="border border-black/10 p-6" data-testid={`order-${o.id}`}>
              <div className="flex items-baseline justify-between mb-4">
                <div>
                  <div className="font-mono-brand text-[10px] uppercase tracking-[0.2em] text-neutral-500">
                    Order · {new Date(o.created_at).toLocaleDateString()}
                  </div>
                  <div className="font-mono-brand text-xs mt-1">{o.id.slice(0, 8).toUpperCase()}</div>
                </div>
                <div className="text-right">
                  <div className="font-display font-black text-2xl tracking-tight">${o.amount.toFixed(2)}</div>
                  <div className="font-mono-brand text-[10px] uppercase tracking-[0.2em] text-[#FF3B30]">{o.status}</div>
                </div>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {o.items.map((it, idx) => (
                  <Link key={idx} to={`/product/${it.product.id}`} className="flex gap-3 items-center hover:text-[#FF3B30]">
                    <img src={it.product.image + "?auto=format&fit=crop&w=200&q=80"} alt={it.product.name} className="w-16 h-16 object-cover" />
                    <div>
                      <div className="text-sm leading-tight">{it.product.name}</div>
                      <div className="font-mono-brand text-[10px] text-neutral-500">x{it.quantity}</div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
